import { render, staticRenderFns } from "./KzsTemplates.vue?vue&type=template&id=0e56835a"
import script from "./KzsTemplates.vue?vue&type=script&lang=js"
export * from "./KzsTemplates.vue?vue&type=script&lang=js"
import style0 from "./KzsTemplates.vue?vue&type=style&index=0&id=0e56835a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports